import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const bscMainnet: VToken[] = [
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0x95c78222B3D6e262426483D42CfA53685A67Ab9D',
    decimals: 8,
    symbol: 'vBUSD',
    underlyingToken: tokens[56][7],
  },
  {
    chainId: 56,
    address: '0x2fF3d0F6990a40261c66E1ff2017aCBc282EB6d0',
    decimals: 8,
    symbol: 'vSXP',
    underlyingToken: tokens[56][4],
  },
  {
    chainId: 56,
    address: '0x151B1e2635A717bcDc836ECd6FbB62B674FE3E1D',
    decimals: 8,
    symbol: 'vXVS',
    underlyingToken: tokens[56][1],
  },
  {
    chainId: 56,
    address: '0xA07c5b74C9B40447a954e1466938b865b6BBea36',
    decimals: 8,
    symbol: 'vBNB',
    underlyingToken: tokens[56][0],
  },
  {
    chainId: 56,
    address: '0x882C173bC7Ff3b7786CA16dfeD3DFFfb9Ee7847B',
    decimals: 8,
    symbol: 'vBTC',
    underlyingToken: tokens[56][8],
  },
  {
    chainId: 56,
    address: '0xf508fCD89b8bd15579dc79A6827cB4686A3592c8',
    decimals: 8,
    symbol: 'vETH',
    underlyingToken: tokens[56][9],
  },
  {
    chainId: 56,
    address: '0x57A5297F2cB2c0AaC9D554660acd6D385Ab50c6B',
    decimals: 8,
    symbol: 'vLTC',
    underlyingToken: tokens[56][10],
  },
  {
    chainId: 56,
    address: '0xB248a295732e0225acd3337607cc01068e3b9c10',
    decimals: 8,
    symbol: 'vXRP',
    underlyingToken: tokens[56][11],
  },
  {
    chainId: 56,
    address: '0x5F0388EBc2B94FA8E123F404b79cCF5f40b29176',
    decimals: 8,
    symbol: 'vBCH',
    underlyingToken: tokens[56][12],
  },
  {
    chainId: 56,
    address: '0x1610bc33319e9398de5f57B33a5b184c806aD217',
    decimals: 8,
    symbol: 'vDOT',
    underlyingToken: tokens[56][13],
  },
  {
    chainId: 56,
    address: '0x650b940a1033B8A1b1873f78730FcFC73ec11f1f',
    decimals: 8,
    symbol: 'vLINK',
    underlyingToken: tokens[56][14],
  },
  {
    chainId: 56,
    address: '0x334b3eCB4DCa3593BCCC3c7EBD1A1C1d1780FBF1',
    decimals: 8,
    symbol: 'vDAI',
    underlyingToken: tokens[56][15],
  },
  {
    chainId: 56,
    address: '0xf91d58b5aE142DAcC749f58A49FCBac340Cb0343',
    decimals: 8,
    symbol: 'vFIL',
    underlyingToken: tokens[56][16],
  },
  {
    chainId: 56,
    address: '0x972207A639CC1B374B893cc33Fa251b55CEB7c07',
    decimals: 8,
    symbol: 'vBETH',
    underlyingToken: tokens[56][17],
  },
  {
    chainId: 56,
    address: '0x9A0AF7FDb2065Ce470D72664DE73cAE409dA28Ec',
    decimals: 8,
    symbol: 'vADA',
    underlyingToken: tokens[56][18],
  },
  {
    chainId: 56,
    address: '0xec3422Ef92B2fb59e84c8B02Ba73F1fE84Ed8D71',
    decimals: 8,
    symbol: 'vDOGE',
    underlyingToken: tokens[56][19],
  },
  {
    chainId: 56,
    address: '0x5c9476FcD6a4F9a3654139721c949c2233bBbBc8',
    decimals: 8,
    symbol: 'vMATIC',
    underlyingToken: tokens[56][20],
  },
  {
    chainId: 56,
    address: '0x86aC3974e2BD0d60825230fa6F355fF11409df5c',
    decimals: 8,
    symbol: 'vCAKE',
    underlyingToken: tokens[56][21],
  },
  {
    chainId: 56,
    address: '0x26DA28954763B92139ED49283625ceCAf52C6f94',
    decimals: 8,
    symbol: 'vAAVE',
    underlyingToken: tokens[56][22],
  },
  {
    chainId: 56,
    address: '0x08CEB3F4a7ed3500cA0982bcd0FC7816688084c3',
    decimals: 8,
    symbol: 'vTUSDOLD',
    underlyingToken: tokens[56][24],
  },
  {
    chainId: 56,
    address: '0x61eDcFe8Dd6bA3c891CB9bEc2dc7657B3B422E93',
    decimals: 8,
    symbol: 'vTRXOLD',
    underlyingToken: tokens[56][26],
  },
  {
    chainId: 56,
    address: '0xC5D3466aA484B040eE977073fcF337f2c00071c1',
    decimals: 8,
    symbol: 'vTRX',
    underlyingToken: tokens[56][25],
  },
  {
    chainId: 56,
    address: '0x6CFdEc747f37DAf3b87a35a1D9c8AD3063A1A8A0',
    decimals: 8,
    symbol: 'vWBETH',
    underlyingToken: tokens[56][27],
  },
  {
    chainId: 56,
    address: '0xBf762cd5991cA1DCdDaC9ae5C638F5B5Dc3Bee6E',
    decimals: 8,
    symbol: 'vTUSD',
    underlyingToken: tokens[56][23],
  },
  {
    chainId: 56,
    address: '0x27FF564707786720C71A2e5c1490A63266683612',
    decimals: 8,
    symbol: 'vUNI',
    underlyingToken: tokens[56][49],
  },
  {
    chainId: 56,
    address: '0xC4eF4229FEc74Ccfe17B2bdeF7715fAC740BA0ba',
    decimals: 8,
    symbol: 'vFDUSD',
    underlyingToken: tokens[56][51],
  },
  {
    chainId: 56,
    address: '0x4d41a36D04D97785bcEA57b057C412b278e6Edcc',
    decimals: 8,
    symbol: 'vTWT',
    underlyingToken: tokens[56][44],
  },
  {
    chainId: 56,
    address: '0xf841cb62c19fCd4fF5CD0AaB5939f3140BaaC3Ea',
    decimals: 8,
    symbol: 'vSolvBTC',
    underlyingToken: tokens[56][55],
  },
  {
    chainId: 56,
    address: '0x86e06EAfa6A1eA631Eab51DE500E3D474933739f',
    decimals: 8,
    symbol: 'vTHE',
    underlyingToken: tokens[56][45],
  },
  {
    chainId: 56,
    address: '0xBf515bA4D1b52FFdCeaBF20d31D705Ce789F2cEC',
    decimals: 8,
    symbol: 'vSOL',
    underlyingToken: tokens[56][57],
  },
  {
    chainId: 56,
    address: '0x689E0daB47Ab16bcae87Ec18491692BF621Dc6Ab',
    decimals: 8,
    symbol: 'vlisUSD',
    underlyingToken: tokens[56][28],
  },
  {
    chainId: 56,
    address: '0x9e4E5fed5Ac5B9F732d0D850A615206330Bf1866',
    decimals: 8,
    symbol: 'vPT-sUSDE-26JUN2025',
    underlyingToken: tokens[56][60],
  },
  {
    chainId: 56,
    address: '0x699658323d58eE25c69F1a29d476946ab011bD18',
    decimals: 8,
    symbol: 'vsUSDe',
    underlyingToken: tokens[56][62],
  },
  {
    chainId: 56,
    address: '0x74ca6930108F775CC667894EEa33843e691680d7',
    decimals: 8,
    symbol: 'vUSDe',
    underlyingToken: tokens[56][61],
  },
  {
    chainId: 56,
    address: '0x0C1DA220D301155b87318B90692Da8dc43B67340',
    decimals: 8,
    symbol: 'vUSD1',
    underlyingToken: tokens[56][63],
  },
  {
    chainId: 56,
    address: '0xd804dE60aFD05EE6B89aab5D152258fD461B07D5',
    decimals: 8,
    symbol: 'vxSolvBTC',
    underlyingToken: tokens[56][64],
  },
  {
    chainId: 56,
    address: '0xCC1dB43a06d97f736C7B045AedD03C6707c09BDF',
    decimals: 8,
    symbol: 'vasBNB',
    underlyingToken: tokens[56][59],
  },
  {
    chainId: 56,
    address: '0x6bCa74586218dB34cdB402295796b79663d816e9',
    decimals: 8,
    symbol: 'vWBNB',
    underlyingToken: tokens[56][42],
  },
  {
    chainId: 56,
    address: '0x89c910Eb8c90df818b4649b508Ba22130Dc73Adc',
    decimals: 8,
    symbol: 'vslisBNB',
    underlyingToken: tokens[56][46],
  },
  {
    chainId: 56,
    address: '0x3d5E269787d562b74aCC55F18Bd26C5D09Fa245E',
    decimals: 8,
    symbol: 'vU',
    underlyingToken: tokens[56][69],
  },
  {
    chainId: 56,
    address: '0x6d3BD68E90B42615cb5abF4B8DE92b154ADc435e',
    decimals: 8,
    symbol: 'vPT-clisBNB-25JUN2026',
    underlyingToken: tokens[56][70],
  },
  {
    chainId: 56,
    address: '0x92e6Ea74a1A3047DabF4186405a21c7D63a0612A',
    decimals: 8,
    symbol: 'vXAUM',
    underlyingToken: tokens[56][71],
  },
  {
    chainId: 56,
    address: '0x97421799419Eb782628e73e7220d8E0A207469a3',
    decimals: 8,
    symbol: 'vTSLAB',
    underlyingToken: tokens[56][72],
  },
  {
    chainId: 56,
    address: '0xEb8Ca841cBe1BC4832A10b15c7dAB1081eDaD371',
    decimals: 8,
    symbol: 'vNVDAB',
    underlyingToken: tokens[56][73],
  },
  {
    chainId: 56,
    address: '0xC36dFaCc7a125859C106F29b9F2d874CCF29A55A',
    decimals: 8,
    symbol: 'vSPCXB',
    underlyingToken: tokens[56][74],
  },
  {
    chainId: 56,
    address: '0x3E281461efb3D53EC20DB207674373Ed8Ef3BbA9',
    decimals: 8,
    symbol: 'vSKHYB',
    underlyingToken: tokens[56][75],
  },
  {
    chainId: 56,
    address: '0x74ca6930108F775CC667894EEa33843e691680d7',
    decimals: 8,
    symbol: 'vUSDe',
    underlyingToken: tokens[56][61],
  },
  {
    chainId: 56,
    address: '0x699658323d58eE25c69F1a29d476946ab011bD18',
    decimals: 8,
    symbol: 'vsUSDe',
    underlyingToken: tokens[56][62],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0x3d5E269787d562b74aCC55F18Bd26C5D09Fa245E',
    decimals: 8,
    symbol: 'vU',
    underlyingToken: tokens[56][69],
  },
  {
    chainId: 56,
    address: '0x882C173bC7Ff3b7786CA16dfeD3DFFfb9Ee7847B',
    decimals: 8,
    symbol: 'vBTC',
    underlyingToken: tokens[56][8],
  },
  {
    chainId: 56,
    address: '0xf841cb62c19fCd4fF5CD0AaB5939f3140BaaC3Ea',
    decimals: 8,
    symbol: 'vSolvBTC',
    underlyingToken: tokens[56][55],
  },
  {
    chainId: 56,
    address: '0xd804dE60aFD05EE6B89aab5D152258fD461B07D5',
    decimals: 8,
    symbol: 'vxSolvBTC',
    underlyingToken: tokens[56][64],
  },
  {
    chainId: 56,
    address: '0x6bCa74586218dB34cdB402295796b79663d816e9',
    decimals: 8,
    symbol: 'vWBNB',
    underlyingToken: tokens[56][42],
  },
  {
    chainId: 56,
    address: '0xCC1dB43a06d97f736C7B045AedD03C6707c09BDF',
    decimals: 8,
    symbol: 'vasBNB',
    underlyingToken: tokens[56][59],
  },
  {
    chainId: 56,
    address: '0x89c910Eb8c90df818b4649b508Ba22130Dc73Adc',
    decimals: 8,
    symbol: 'vslisBNB',
    underlyingToken: tokens[56][46],
  },
  {
    chainId: 56,
    address: '0x6d3BD68E90B42615cb5abF4B8DE92b154ADc435e',
    decimals: 8,
    symbol: 'vPT-clisBNB-25JUN2026',
    underlyingToken: tokens[56][70],
  },
  {
    chainId: 56,
    address: '0x650b940a1033B8A1b1873f78730FcFC73ec11f1f',
    decimals: 8,
    symbol: 'vLINK',
    underlyingToken: tokens[56][14],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0x27FF564707786720C71A2e5c1490A63266683612',
    decimals: 8,
    symbol: 'vUNI',
    underlyingToken: tokens[56][49],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0x26DA28954763B92139ED49283625ceCAf52C6f94',
    decimals: 8,
    symbol: 'vAAVE',
    underlyingToken: tokens[56][22],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0xec3422Ef92B2fb59e84c8B02Ba73F1fE84Ed8D71',
    decimals: 8,
    symbol: 'vDOGE',
    underlyingToken: tokens[56][19],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0x5F0388EBc2B94FA8E123F404b79cCF5f40b29176',
    decimals: 8,
    symbol: 'vBCH',
    underlyingToken: tokens[56][12],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0x4d41a36D04D97785bcEA57b057C412b278e6Edcc',
    decimals: 8,
    symbol: 'vTWT',
    underlyingToken: tokens[56][44],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0x9A0AF7FDb2065Ce470D72664DE73cAE409dA28Ec',
    decimals: 8,
    symbol: 'vADA',
    underlyingToken: tokens[56][18],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0x57A5297F2cB2c0AaC9D554660acd6D385Ab50c6B',
    decimals: 8,
    symbol: 'vLTC',
    underlyingToken: tokens[56][10],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0xf91d58b5aE142DAcC749f58A49FCBac340Cb0343',
    decimals: 8,
    symbol: 'vFIL',
    underlyingToken: tokens[56][16],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0xC5D3466aA484B040eE977073fcF337f2c00071c1',
    decimals: 8,
    symbol: 'vTRX',
    underlyingToken: tokens[56][25],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0x1610bc33319e9398de5f57B33a5b184c806aD217',
    decimals: 8,
    symbol: 'vDOT',
    underlyingToken: tokens[56][13],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0x86e06EAfa6A1eA631Eab51DE500E3D474933739f',
    decimals: 8,
    symbol: 'vTHE',
    underlyingToken: tokens[56][45],
  },
  {
    chainId: 56,
    address: '0xfD5840Cd36d94D7229439859C0112a4185BC0255',
    decimals: 8,
    symbol: 'vUSDT',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xecA88125a5ADbe82614ffC12D0DB554E2e2867C8',
    decimals: 8,
    symbol: 'vUSDC',
    underlyingToken: tokens[56][5],
  },
  {
    chainId: 56,
    address: '0xCa2D81AA7C09A1a025De797600A7081146dceEd9',
    decimals: 8,
    symbol: 'vlisUSD_Stablecoins',
    underlyingToken: tokens[56][28],
  },
  {
    chainId: 56,
    address: '0x5e3072305F9caE1c7A82F6Fe9E38811c74922c3B',
    decimals: 8,
    symbol: 'vUSDT_Stablecoins',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xc3a45ad8812189cAb659aD99E64B1376f6aCD035',
    decimals: 8,
    symbol: 'vUSDD_Stablecoins',
    underlyingToken: tokens[56][29],
  },
  {
    chainId: 56,
    address: '0x795DE779Be00Ea46eA97a28BDD38d9ED570BCF0F',
    decimals: 8,
    symbol: 'vEURA_Stablecoins',
    underlyingToken: tokens[56][47],
  },
  {
    chainId: 56,
    address: '0x53728FD51060a85ac41974C6C3Eb1DaE42776723',
    decimals: 8,
    symbol: 'vankrBNB_DeFi',
    underlyingToken: tokens[56][39],
  },
  {
    chainId: 56,
    address: '0x8f657dFD3a1354DEB4545765fE6840cc54AFd379',
    decimals: 8,
    symbol: 'vBSW_DeFi',
    underlyingToken: tokens[56][36],
  },
  {
    chainId: 56,
    address: '0x02c5Fb0F26761093D297165e902e96D08576D344',
    decimals: 8,
    symbol: 'vALPACA_DeFi',
    underlyingToken: tokens[56][37],
  },
  {
    chainId: 56,
    address: '0x1D8bBDE12B6b34140604E18e9f9c6e14deC16854',
    decimals: 8,
    symbol: 'vUSDT_DeFi',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xA615467caE6B9E0bb98BC04B4411d9296fd1dFa0',
    decimals: 8,
    symbol: 'vUSDD_DeFi',
    underlyingToken: tokens[56][29],
  },
  {
    chainId: 56,
    address: '0x19CE11C8817a1828D1d357DFBF62dCf5b0B2A362',
    decimals: 8,
    symbol: 'vANKR_DeFi',
    underlyingToken: tokens[56][38],
  },
  {
    chainId: 56,
    address: '0x736bf1D21A28b5DC19A1aC8cA71Fc2856C23c03F',
    decimals: 8,
    symbol: 'vTWT_DeFi',
    underlyingToken: tokens[56][44],
  },
  {
    chainId: 56,
    address: '0xFf1112ba7f88a53D4D23ED4e14A117A2aE17C6be',
    decimals: 8,
    symbol: 'vPLANET_DeFi',
    underlyingToken: tokens[56][50],
  },
  {
    chainId: 56,
    address: '0xE5FE5527A5b76C75eedE77FdFA6B80D52444A465',
    decimals: 8,
    symbol: 'vRACA_GameFi',
    underlyingToken: tokens[56][33],
  },
  {
    chainId: 56,
    address: '0xc353B7a1E13dDba393B5E120D4169Da7185aA2cb',
    decimals: 8,
    symbol: 'vFLOKI_GameFi',
    underlyingToken: tokens[56][34],
  },
  {
    chainId: 56,
    address: '0x4978591f17670A846137d9d613e333C38dc68A37',
    decimals: 8,
    symbol: 'vUSDT_GameFi',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0x9f2FD23bd0A5E08C5f2b9DD6CF9C96Bfb5fA515C',
    decimals: 8,
    symbol: 'vUSDD_GameFi',
    underlyingToken: tokens[56][29],
  },
  {
    chainId: 56,
    address: '0xBfe25459BA784e70E2D7a718Be99a1f3521cA17f',
    decimals: 8,
    symbol: 'vankrBNB_LiquidStakedBNB',
    underlyingToken: tokens[56][39],
  },
  {
    chainId: 56,
    address: '0x5E21bF67a6af41c74C1773E4b473ca5ce8fd3791',
    decimals: 8,
    symbol: 'vBNBx_LiquidStakedBNB',
    underlyingToken: tokens[56][40],
  },
  {
    chainId: 56,
    address: '0xcc5D9e502574cda17215E70bC0B4546663785227',
    decimals: 8,
    symbol: 'vstkBNB_LiquidStakedBNB',
    underlyingToken: tokens[56][41],
  },
  {
    chainId: 56,
    address: '0xe10E80B7FD3a29fE46E16C30CC8F4dd938B742e2',
    decimals: 8,
    symbol: 'vWBNB_LiquidStakedBNB',
    underlyingToken: tokens[56][42],
  },
  {
    chainId: 56,
    address: '0xd3CC9d8f3689B83c91b7B59cAB4946B063EB894A',
    decimals: 8,
    symbol: 'vslisBNB_LiquidStakedBNB',
    underlyingToken: tokens[56][46],
  },
  {
    chainId: 56,
    address: '0xA537ACf381b12Bbb91C58398b66D1D220f1C77c8',
    decimals: 8,
    symbol: 'vPT-clisBNB-24APR2025_LiquidStakedBNB',
    underlyingToken: tokens[56][58],
  },
  {
    chainId: 56,
    address: '0x4A50a0a1c832190362e1491D5bB464b1bc2Bd288',
    decimals: 8,
    symbol: 'vasBNB_LiquidStakedBNB',
    underlyingToken: tokens[56][59],
  },
  {
    chainId: 56,
    address: '0x49c26e12959345472E2Fd95E5f79F8381058d3Ee',
    decimals: 8,
    symbol: 'vBTT_Tron',
    underlyingToken: tokens[56][30],
  },
  {
    chainId: 56,
    address: '0xb114cfA615c828D88021a41bFc524B800E64a9D5',
    decimals: 8,
    symbol: 'vWIN_Tron',
    underlyingToken: tokens[56][32],
  },
  {
    chainId: 56,
    address: '0x836beb2cB723C498136e1119248436A645845F4E',
    decimals: 8,
    symbol: 'vTRX_Tron',
    underlyingToken: tokens[56][25],
  },
  {
    chainId: 56,
    address: '0x281E5378f99A4bc55b295ABc0A3E7eD32Deba059',
    decimals: 8,
    symbol: 'vUSDT_Tron',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0xf1da185CCe5BeD1BeBbb3007Ef738Ea4224025F7',
    decimals: 8,
    symbol: 'vUSDD_Tron',
    underlyingToken: tokens[56][29],
  },
  {
    chainId: 56,
    address: '0x52eD99Cd0a56d60451dD4314058854bc0845bbB5',
    decimals: 8,
    symbol: 'vBabyDoge_Meme',
    underlyingToken: tokens[56][52],
  },
  {
    chainId: 56,
    address: '0x4a9613D06a241B76b81d3777FCe3DDd1F61D4Bd0',
    decimals: 8,
    symbol: 'vUSDT_Meme',
    underlyingToken: tokens[56][6],
  },
  {
    chainId: 56,
    address: '0x94180a3948296530024Ef7d60f60B85cfe0422c8',
    decimals: 8,
    symbol: 'vwstETH_LiquidStakedETH',
    underlyingToken: tokens[56][54],
  },
  {
    chainId: 56,
    address: '0xc5b24f347254bD8cF8988913d1fd0F795274900F',
    decimals: 8,
    symbol: 'vweETH_LiquidStakedETH',
    underlyingToken: tokens[56][53],
  },
  {
    chainId: 56,
    address: '0xeCCACF760FEA7943C5b0285BD09F601505A29c05',
    decimals: 8,
    symbol: 'vETH_LiquidStakedETH',
    underlyingToken: tokens[56][9],
  },
  {
    chainId: 56,
    address: '0x8F2AE20b25c327714248C95dFD3b02815cC82302',
    decimals: 8,
    symbol: 'vBTCB_BTC',
    underlyingToken: tokens[56][8],
  },
];
